<editor
    apiKey="w0z4cgzii58ocmpmxrf027jy2veiglikxljegfvob6enesau"
    [class.dark]="isDarkMode"
    [init]="config"
    tagName="my-custom-tag"
    [(ngModel)]="currentData"
></editor>
